import moment from 'moment-timezone';

export const isDate = (dateAsString: string) => moment(dateAsString, moment.ISO_8601, true).isValid();
